export default {
  title: 'Cómo funcionan las comisiones de procesamiento',
  how_it_works:
    'Stripe cobra su comisión a tu plataforma en cada pago online que reciben tus restaurantes. La comisión de procesamiento que establezcas es lo que paga el restaurante por ese pago. Si es superior a la de Stripe, te quedas con la diferencia como margen. Si es inferior, o no estableces ninguna, la diferencia la pagas tú.',
  stripe_rates_link: 'Ver las tarifas estándar de Stripe',
  example: {
    intro:
      'Ejemplo: un pedido de {{total}} pagado con tarjeta. Stripe cobra a tu plataforma {{stripe_fee}} ({{stripe_rate}}).',
    above: 'Tu tarifa {{rate}}: el restaurante paga {{fee}}, tú te quedas con {{difference}}.',
    below: 'Tu tarifa {{rate}}: el restaurante paga {{fee}}, tú pagas la diferencia de {{difference}}.',
    none: 'Sin tarifa (margen del 0 %): el restaurante no paga nada, tú pagas los {{stripe_fee}} completos.',
    disclaimer:
      'La comisión de Stripe aquí es su tarifa estándar de tarjeta en el EEE, solo a modo de ejemplo. Tu comisión real depende de la tarjeta, su país y tu tarifa de Stripe.',
  },
};
